import * as NotificationActions from '../../state/notification/notification.action';

class BrowserUpdateBannerController {
  constructor(browser, $window, $state, $ngRedux) {
    'ngInject';

    this.$window = $window;
    this.$state = $state;
    this.store = $ngRedux;
    this.currentBrowser = browser;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, NotificationActions)(this);
  }

  $postLink() {
    this.checkSupport();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    let { visible } = state.notification;
    return { visible };
  }

  checkSupport() {
    this.checkBrowserSupportNotification(!this.currentBrowser.supported);
  }

  dismiss() {
    this.dismissNotification();
  }
  browserPolicy() {
    this.$state.go('browser-policy');
  }
}

export default {
  template: require('./browserUpdateBanner.html'),
  controller: BrowserUpdateBannerController,
  bindings: {},
  controllerAs: 'vm'
};
